import ThreeArticles  from "../components/three-articles";

const test = ({ __typename }: { __typename: string }): boolean => {
    return __typename === "VinoData_ThreeArticles";
}
const create = (data): JSX.Element => {
    if (!Array.isArray(data.articlesPages)) {
      return <></>;   
    }
    return <ThreeArticles data={data.articlesPages} />;
};

export default { test, create };
